module.exports = __webpack_public_path__ + "static/media/441637870_1610911406334851_473478369037332570_n.33bd0081.jpg";